module.exports = __webpack_public_path__ + "img/crystal-search.eab90166.png";